export const resolveStudentName = (
  data: {
    studentsCustomNames?: string
    customNames?: string
    students?: { name: string }[]
    name: string
  },
  separator = ", ",
): string => {
  const custom = data.studentsCustomNames ?? data.customNames
  if (custom) return custom
  if (data.students?.length) {
    return data.students.map(s => s.name).join(separator) || data.name
  }
  return data.name
}

export const getObjectFocus = (focusJSONString?: string): string => {
  if (!focusJSONString) {
    return "50% 50%"
  }
  const focus = JSON.parse(focusJSONString) as {
    x: number
    y: number
  }
  // Return as CSS object position percentage
  return `${focus.x * 100}% ${focus.y * 100}%`
}
